window.app.directive("hours", [
  "$timeout",
  "$watchRefresh",
  function($timeout, $watchRefresh) {
    var debug = false;

    return {
      restrict: "A",
      scope: false,
      template:
        '<div class="integer"></div><div class="fraction2 flex-column ng-hide"></div>',
      link: function(scope, element, attrs) {
        var fractionVisible = false;
        var fraction = element[0].querySelector(".fraction2");
        var integer = element[0].querySelector(".integer");

        scope.$watch(attrs.hours, refreshHours);
        $watchRefresh(scope, attrs.hoursRefreshWhen, attrs.hours, refreshHours);
        function refreshHours(hours) {
          debug &&
            console.log(
              "hours",
              hours,
              scope.project &&
                scope.project
                  .hours /*, scope.project && scope.project.tasksMap.reduce(function(acc, value) {
                    return acc + value.hours;
                }, 0) */
            );
          hours = hours || 0;
          integer.textContent = getInteger(hours);
          if (isInteger(hours)) {
            fractionVisible && fraction.classList.add("ng-hide");
            fractionVisible = false;
          } else {
            fractionVisible || fraction.classList.remove("ng-hide");
            fractionVisible = true;
            fraction.textContent = getDecimal(hours);
          }
        }
      }
    };

    function getInteger(value) {
      return Math.floor(value) || 0;
    }
    function isInteger(value) {
      return (value || 0) % 1 === 0;
    }
    function getDecimal(value) {
      var decimal = value % 1;
      if (decimal === 0.75) {
        return ".75";
      } else if (decimal === 0.5) {
        return ".5";
      } else if (decimal === 0.25) {
        return ".25";
      }
      return "";
    }
  }
]);



// WEBPACK FOOTER //
// ./src/directives/hours.js